import {call, put, race, select, take} from 'redux-saga/effects';
import 'regenerator-runtime';
import {Notification} from '../classes/Notification';
import locale from '../locale/Localization';
import {validateSession} from '../script/webauthn-service';
import {
  ADD_NOTIFICATIONS,
  START_SESSION_POLLING,
  STOP_SESSION_POLLING,
  USER_LOGOUT
} from '../store/action-types';

const isActive = (state) => state.active;

/**
 * Delay function.
 * @param {*} duration
 * @return {Propise} a new promise.
 */
function delay(duration) {
  const promise = new Promise((resolve) => {
    setTimeout(() => resolve(true), duration);
  });
  return promise;
}

/**
 * Fetchs the session
 */
function* fetchSession() {
  let logoutTime = 1000;
  while (true) {
    try {
      console.log('start session polling logout time ' + logoutTime);
      const active = yield select(isActive);
      if (active) {
        const data = yield call(() =>
          validateSession().then((response) => {
            return response;
          })
        );
        if (data.expired) {
          yield put({type: USER_LOGOUT});
          yield put({type: STOP_SESSION_POLLING});
        } else {
          console.log(data.expires);
          logoutTime = data.expires / 1000 - 60;
          console.log('new logout time in ' + logoutTime);
        }
        // after a session update wait for 60 sekonds until the next update will start.
        yield call(delay, 60000);
      } else {
        // if the use is inactive wait for 10 sekonds
        if (logoutTime < 60 && logoutTime > 0) {
          console.log('logout in ' + logoutTime);

          const notificationText = locale.formatString(
            locale.userInactiveNotification,
            Math.round(logoutTime)
          );
          const notification = new Notification(
            notificationText,
            'warning',
            10000
          );
          yield put({type: ADD_NOTIFICATIONS, payload: [notification]});
        } else if (logoutTime < 0) {
          yield put({type: USER_LOGOUT});
          yield put({type: STOP_SESSION_POLLING});
        }
        logoutTime -= 10;
        yield call(delay, 10000);
      }
    } catch (e) {
      console.debug('Session polling error ' + e.message);
    }
  }
}

/**
 * Watcher for session saga.
 */
export default function* watchPollSessionSaga() {
  while (true) {
    const data = yield take(START_SESSION_POLLING);
    yield race([call(fetchSession, data), take(STOP_SESSION_POLLING)]);
  }
}
